import { useQuery } from '@tanstack/react-query';
import { patientLabValuesService, type PatientKidneyFunction } from '../../services/patientLabValuesService';

/** One key for the kidney-function read, shared by the Patient info card and the Rx grid flag. */
export const patientLabValuesQueryKey = (pharmacyId?: string, patientId?: string) =>
  ['patient', 'lab-values', pharmacyId, patientId] as const;

/**
 * PRX-145 (WP-20) — a patient's kidney-function labs, latest first, with the
 * CrCl, CKD stage and renal-dosing flag the backend computed. Disabled until
 * both ids are present.
 */
export function usePatientLabValues(pharmacyId?: string, patientId?: string) {
  return useQuery({
    queryKey: patientLabValuesQueryKey(pharmacyId, patientId),
    queryFn: (): Promise<PatientKidneyFunction> =>
      patientLabValuesService.list(pharmacyId as string, patientId as string),
    enabled: !!pharmacyId && !!patientId,
    staleTime: 60_000,
  });
}
